
export const baseApiUrl = 'https://ecommerce.primavida.com.br/api/'
//export const baseApiUrl = 'http://localhost:3002/api/'
export const userKey = '__primavida_user'
export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    convenioId: 'd22ab8d1-061b-4c9f-9bc7-6b1be6dae1ed'
}

export default { baseApiUrl, modelBoleto }